import React, { useEffect } from "react";

interface CalendlyEmbedProps {
  url: string;
  height?: number;
  className?: string;
  prefill?: Record<string, string>;
  utm?: Record<string, string>;
}

const CalendlyEmbed: React.FC<CalendlyEmbedProps> = ({
  url,
  height = 700,
  className = "",
  prefill = {},
  utm = {},
}) => {
  // Load the Calendly script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up
      document.body.removeChild(script);
    };
  }, []);

  // Build URL with prefill and UTM parameters if provided
  const buildUrl = () => {
    const baseUrl = url;
    const params = new URLSearchParams();

    // Add prefill parameters
    if (Object.keys(prefill).length > 0) {
      Object.entries(prefill).forEach(([key, value]) => {
        params.append(`prefill[${key}]`, value);
      });
    }

    // Add UTM parameters
    if (Object.keys(utm).length > 0) {
      Object.entries(utm).forEach(([key, value]) => {
        params.append(`utm[${key}]`, value);
      });
    }

    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  };

  return (
    <div
      className={`calendly-inline-widget ${className}`}
      data-url={buildUrl()}
      style={{ minWidth: 320, height: height }}
    />
  );
};

export default CalendlyEmbed;
